import { Box, MenuItem, Text } from '@chakra-ui/react';
import Dialog from 'components/Dialog';
import RoleDropdown, { ROLE_OPTIONS } from 'components/RoleDropdown';
import MemberCell, { TMemberCell } from 'components/Table/Cells/MemberCell';
import showMessage from 'providers/NoticeProvider/showMessage';
import { useState } from 'react';
import { LiaUserEditSolid } from 'react-icons/lia';
import { ROLES } from 'store/types';

type TProps = {
    user: TMemberCell;
    teamName: string;
};

const ChangeRoleDialog = ({ user, teamName }: TProps) => {
    const initial = ROLE_OPTIONS.find(item => item.value === ROLES.admin);
    const [value, setSelectedOption] = useState(initial);

    const handleChange = (value: any) => {
        setSelectedOption(value);
    };

    const handleSubmit = () => {
        showMessage("The team member's role has been successfully changed.");
    };

    const disabled = value === initial;

    return (
        <Dialog
            size="lg"
            title="Change role"
            trigger={<MenuItem icon={<LiaUserEditSolid />}>Change role</MenuItem>}
            submitText="Change role"
            onSubmit={handleSubmit}
            disabled={disabled}
        >
            <Box>
                <Text color="gray.500" fontSize="16px" fontWeight={500} lineHeight={1.5} mb="24px">
                    Team:{' '}
                    <Text color="gray.900" as="span">
                        {teamName}
                    </Text>
                </Text>
                <MemberCell {...user} />
                <RoleDropdown sx={{ mt: '24px' }} label="Role" value={value} onChange={handleChange} />
            </Box>
        </Dialog>
    );
};

export default ChangeRoleDialog;
